import { styled as e } from "styled-components";
import { RichEditor as r } from "../../../../../RichEditor/index.js";
const i = e(r)`
  grid-area: textArea;

  ul {
    padding: 0 calc(1rem + 2px) !important; // force orverride quill style
    li {
      list-style: circle !important; // force orverride quill style
      &::before {
        content: none;
      }
    }
  }
`;
export {
  i as CommentRichText
};
